'use client';

import { useCartStore } from '@/features/cart/stores/cartStore';
import { Product } from "@/features/product/types/models/product";
import { useRouter } from 'next/navigation';
import { useChatStore } from '../../stores/chatStore';

interface ProductMessageCardProps {
  productData: Product;
  senderName: string;
  isOwn: boolean;
}

export function ProductMessageCard({ productData, isOwn }: ProductMessageCardProps) {
  const { addToCart } = useCartStore();
  const { toggleOverlay } = useChatStore();
  const router = useRouter();

  const isArchived = productData.status === 'ARCHIVED';
  const shouldHideButton = Number(productData.productId) === -1;
  const isButtonDisabled = isArchived;

  const handleAddToCart = () => {
    if (!productData.productId || isButtonDisabled) return;

    addToCart(productData.productId as number);
    toggleOverlay();
    router.push('/cart');
  };

  const getButtonStyle = () => {
    if (isButtonDisabled) return 'bg-gray-400 text-white cursor-not-allowed';

    switch (productData.status) {
      case 'ARCHIVED':
        return 'bg-gray-400 text-white cursor-not-allowed';
      case 'ACTIVE':
        return 'bg-blue-600 text-white hover:bg-blue-700';
      default:
        return 'bg-blue-600 text-white hover:bg-blue-700';
    }
  };

  const getButtonText = () => {
    switch (productData.status) {
      case 'ARCHIVED':
        return '구매 불가';
      case 'ACTIVE':
        return '장바구니 담기';
      default:
        return '장바구니 담기';
    }
  };

  return (
    <div className={`max-w-sm rounded-lg p-4 ${isOwn ? 'bg-blue-50' : 'bg-[#F0F2F4]'}`}>
      <div className="flex-1">
        <div className="space-y-1 text-xs text-gray-600">
          <div className="flex justify-between">
            <span>축종:</span>
            <span>{productData.meatType}</span>
          </div>
          <div className="flex justify-between">
            <span>원산지:</span>
            <span>{productData.origin}</span>
          </div>
          <div className="flex justify-between">
            <span>보관:</span>
            <span>{productData.storageType}</span>
          </div>
          <div className="flex justify-between">
            <span>품목:</span>
            <span>{productData.meatLoin}</span>
          </div>
          <div className="flex justify-between">
            <span>브랜드:</span>
            <span>{productData.brand}</span>
          </div>
          <div className="flex justify-between">
            <span>등급:</span>
            <span>{productData.grade}</span>
          </div>
          <div className="flex justify-between">
            <span>EST:</span>
            <span>{productData.est}</span>
          </div>
          <div className="flex justify-between">
            <span>평중(kg):</span>
            <span>{productData.averageWeight.toString()}</span>
          </div>
          <div className="flex justify-between">
            <span>판매가(원):</span>
            <span>{productData.price.toString()}</span>
          </div>
          <div className="flex justify-between">
            <span>창고:</span>
            <span>{productData.warehouse}</span>
          </div>
          <div className="flex justify-between">
            <span>소비기한:</span>
            <span>{productData.expiryDate}</span>
          </div>
          <div className="flex justify-between">
            <span>스펙/설명:</span>
            <span>{productData.description}</span>
          </div>
        </div>
        {!shouldHideButton && (
          <button
            onClick={handleAddToCart}
            disabled={isButtonDisabled}
            className={`w-full mt-3 py-2 px-4 rounded-lg font-medium text-sm transition-colors ${getButtonStyle()}`}
          >
            {getButtonText()}
          </button>
        )}
      </div>
    </div>
  );
}
